import { FaRocket } from "react-icons/fa";
import { FaRegMoon } from "react-icons/fa";
import { FaWpexplorer } from "react-icons/fa";
import { FaHotjar } from "react-icons/fa";

export const ExperienceData = [
  {
    experienceTitle: "Mid Level Full-stack Developer",
    experienceSubTitle: "Peak One Dev · Nov 2024 - Apr 2025",
    experienceDesc: [
      "Developed custom software and web pages tailored to business needs.",
      "Created API integrations for e-commerce platforms and project-specific features.",
      "Built tailored solutions that optimized workflows and drove innovation.",
      "Enhanced UX with a focus on usability and performance.",
      "Delivered projects with quality, efficiency, and creative problem-solving.",
    ],
    experiencePosition: "right",
    markerIcon: <FaRocket />,
    markerColor: "#8a43f2",
  },
  {
    experienceTitle: "Full-stack Developer",
    experienceSubTitle: "CordWork · Sep 2023 - Nov 2024",
    experienceDesc: [
      "Developed a SaaS employee management solution for client interaction and key management.",
      "Integrated subscription-based payment system and secure login authentication.",
      "Implemented employee time tracking and reporting functionality.",
      "Handled planning, architecture, implementation, and testing phases.",
      "Delivered efficient team management tools across multiple businesses.",
    ],
    experiencePosition: "left",
    markerIcon: <FaHotjar />,
    markerColor: "#d73c2c",
  },
  {
    experienceTitle: "Full-stack Developer",
    experienceSubTitle: "GPWorks · Dec 2023 - Jun 2024",
    experienceDesc: [
      "Led full-stack development from initial idea through implementation.",
      "Contributed to business growth by assisting in sales and strategic planning.",
      "Worked with React, TypeScript, NestJS, and PostgreSQL on scalable web apps.",
      "Collaborated closely with teams to ensure seamless feature delivery.",
      "Maintained code quality and consistent deployment pipelines.",
    ],
    experiencePosition: "right",
    markerIcon: <FaHotjar />,
    markerColor: "#8a43f2",
  },
  {
    experienceTitle: "Full Stack Developer (Freelancer)",
    experienceSubTitle: "Jul 2023 - Dec 2023",
    experienceDesc: [
      "Developed web applications for global clients using React, NestJS, Node, TypeScript, and PostgreSQL.",
      "Built reliable solutions focused on performance and scalability.",
      "Collaborated remotely across multiple time zones and projects.",
      "Enhanced technical and problem-solving skills through diverse freelance work.",
    ],
    experiencePosition: "left",
    markerIcon: <FaWpexplorer />,
    markerColor: "#d73c2c",
  },
  {
    experienceTitle: "Full Stack Blockchain Developer",
    experienceSubTitle: "Freelance · Dec 2022 - Dec 2023",
    experienceDesc: [
      "Independently developed a fully functional decentralized exchange (DEX) platform.",
      "Handled smart contract integration and frontend implementation.",
      "Ensured system reliability through continuous testing and debugging.",
      "Recognized for technical excellence and attention to detail in blockchain architecture.",
      "Applied deep knowledge of blockchain protocols and DEX development best practices.",
    ],
    experiencePosition: "right",
    markerIcon: <FaRegMoon />,
    markerColor: "#8a43f2",
  },
];
